import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Story from "./components/Story";
import ProductsSection from "./components/ProductsSection";
import HunterSection from "./components/HunterSection";
import LeatherSection from "./components/LeatherSection";
import ShippingContact from "./components/ShippingContact";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Story />
        <ProductsSection />
        <HunterSection />
        <LeatherSection />
        <ShippingContact />
      </main>
      <Footer />
    </div>
  );
}